import { useState } from "react"
import PropTypes from "prop-types"
import { DialogContent, DialogActions, Button, TextField, DialogContentText } from "@mui/material"
import "./styles.scss"

export default function ConfirmWithMfa({ close, save, saveText, message }) {
  const [token, setToken] = useState()

  const handleChange = (e) => {
    if (e.target.name === "token") {
      setToken(e.target.value)
    }
  }

  const onSave = () => {
    save(token)
    close()
  }

  const onKeyPress = event => {
    if (event.key === "Enter" && token) {
      event.preventDefault()
      onSave()
    }
  }

  return (<>
    <DialogContent className="modules_user-profile_components_confirm-with-mfa">
      <DialogContentText>{message}</DialogContentText>
      <TextField
        className="token-box"
        name="token"
        onChange={handleChange}
        onKeyPress={onKeyPress}
        autoFocus
        placeholder="Authentication Code"
        variant="outlined"
      />
    </DialogContent>
    <DialogActions>
      <Button color="secondary" onClick={close}>Cancel</Button>
      <Button color="primary" onClick={onSave} disabled={!token}>
        {saveText}
      </Button>
    </DialogActions>
  </>)
}

ConfirmWithMfa.propTypes = {
  close: PropTypes.func,
  save: PropTypes.func.isRequired,
  saveText: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
}
